import { render } from "./OpenRhWebSpecialEvents.vue?vue&type=template&id=4d2f98d3"
import script from "./OpenRhWebSpecialEvents.vue?vue&type=script&lang=js"
export * from "./OpenRhWebSpecialEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__